<template>
  <div>
    <container-headline
      :headline="$t('global.companies_departments')"
      :col="6"
    ></container-headline>

    <div class="row mb-3">
      <div class="col-xl-12 block br-t-l-0">
        <div
          class="eingabe-panel-kopf p-3 abteilungPanel"
          ref="abteilungPanel"
          :style="
            abteilungen.length > 4 ? abteilungPanelStyle : 'height: 246.5px;'
          "
        >
          <div class="row">
            <div class="col-xl-12">
              <button
                class="btn btn-primary btn-sm"
                @click="abteilungHinzufuegen()"
                :disabled="!editable"
              >
                <font-awesome-icon icon="fa-regular fa-plus" class="mr-1" />
                {{ $t("global.addDepartment") }}
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <b-table
                  ref="abteilungenTable"
                  tbody-tr-class="item"
                  show-empty
                  :items="abteilungen"
                  :fields="fields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  sort-icon-left
                  borderless
                  thead-class="d-none"
                >
                  <template
                    #cell(bezeichnung)="row"
                    class="d-flex align-items-center"
                  >
                    <input
                      v-model="row.item.bezeichnung"
                      class="form-control"
                      :placeholder="$t('global.newDepartment')"
                      :readonly="!editable"
                    />
                  </template>

                  <template
                    #cell(delete)="row"
                    class="d-flex align-items-center"
                  >
                    <button
                      class="btn btn-danger btn-sm"
                      @click="abteilungLoeschen(row.item)"
                      style="height: 33px"
                      :disabled="!editable"
                    >
                      <font-awesome-icon
                        icon="fa-duotone fa-trash"
                        class="mr-1 pl-1"
                      />
                    </button>
                  </template>

                  <template #empty>
                    <div class="text-center text-primary my-2">
                      <strong>{{ $t("global.nodataavailable") }}</strong>
                    </div>
                  </template>

                  <template #table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"
                      :key="field.key"
                      :style="{
                        width: field.key === 'delete' ? '10%' : '90%',
                      }"
                    />
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContainerHeadline from "@/components/ContainerHeadline";

export default {
  name: "Firma-Abteilungen",
  components: {
    ContainerHeadline,
  },
  mixins: [],
  props: {
    editable: {
      type: Boolean,
      required: true,
    },
    abteilungen: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      sortBy: "",
      sortDesc: false,
      abteilungPanelStyle: {
        height: "246.5px",
        "overflow-y": "scroll",
      },
    };
  },
  computed: {
    fields() {
      return [
        {
          key: "bezeichnung",
          sortable: true,
          tdClass: "p-0 pb-1 pr-1",
        },
        {
          key: "delete",
          sortable: false,
          label: this.$t("global.delete"),
          tdClass: "p-0 d-flex align-items-center",
        },
      ];
    },
  },
  created() {},
  watch: {},
  mounted: function () {},
  methods: {
    abteilungLoeschen(item) {
      this.$emit("abteilungLoeschen", item);
    },
    abteilungHinzufuegen() {
      this.$emit("abteilungHinzufuegen");
    },
  },
};
</script>

<style>
/* Firefox */
*.abteilungPanel {
  scrollbar-width: thin;
  scrollbar-color: #deedf6 #f5fbff;
}

/* Chrome, Edge, und Safari */
*.abteilungPanel::-webkit-scrollbar {
  width: 12px;
}

*.abteilungPanel::-webkit-scrollbar-track {
  background: #f5fbff;
  border-radius: 0 0 6px 0;
}

*.abteilungPanel::-webkit-scrollbar-thumb {
  background-color: #deedf6;
  border-radius: 20px;
  border: 3px solid #f5fbff;
}
</style>
